<nav class="recent-quizzes" aria-labelledby="recent-quizzes-title">
  <h3 id="recent-quizzes-title" class="title">Recent Quizzes</h3>
  @if (loading() && !items().length) {
    <p class="state" role="status">Loading…</p>
  } @else if (!items().length) {
    <p class="state">No quizzes yet.</p>
  } @else {
    <ul class="list">
      @for (item of items(); track item.chat_session_id) {
        <li>
          <button
            type="button"
            class="item"
            [class.active]="selectedId() === item.chat_session_id"
            [attr.aria-current]="selectedId() === item.chat_session_id ? 'true' : null"
            [title]="label(item)"
            (click)="open.emit(item.chat_session_id)"
          >
            <span class="item-title">{{ label(item) }}</span>
            <span class="item-date">{{ item.chat_start_time | date: 'mediumDate' }}</span>
          </button>
        </li>
      }
    </ul>
  }
</nav>
